import React from "react"
import { useSelector, useDispatch } from "react-redux"
import CustomTag from "components/Atoms/CustomTag"
import { SELECT_ROW } from "store/selector.redux"

export default function SelectedMessage() {
  const selected = useSelector(state => state.selector.vehicles.selected)
  const vehicles = Object.values(selected)
  const dispatch = useDispatch()
  return (
    <div className="vt-vehicle-selected-message">
      <span className="vt-highlight mr-2">{vehicles?.length ?? 0}</span>
      <span>Vehicles</span>
      <div className={vehicles?.length > 0 ? "mt-2" : null}>
        {vehicles.map(v => (
          <CustomTag
            key={v?.id}
            className="mr-1 mb-1"
            minimal
            onRemove={() => {
              dispatch({
                type: SELECT_ROW,
                path: "vehicles",
                payload: v,
              })
            }}
          >
            {v?.registrationNumber}
          </CustomTag>
        ))}
      </div>
    </div>
  )
}
